import React, { useCallback, useEffect } from "react";
import Icon from "@ant-design/icons";
import { notification } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { ReactComponent as CheckGreen } from "@assets/images/svg/circle-tick_green.svg";
import { ReactComponent as CloseRed } from "@assets/images/svg/falseRed.svg";
import constants from "@constants/constants";
import { clearApiMsg } from "@redux/actionCreators";

import "./styles.scss";

const { API_SUCCESS, API_ERROR, API_MSG_PLACEMENT, API_SUCCESS_INFO, API_MSG_TIME } = constants;

const ApiMessage = () => {
	const dispatch = useDispatch();
	const apiMessage = useSelector(state => state.apiMessageReducer, shallowEqual);
	const { successMessage, errorMessage } = apiMessage;

	const messageTrigger = useCallback((msg = "", type, title) => {
		if (msg?.length > 0) {
			notification[type]({
				top: API_MSG_PLACEMENT,
				className: `api-notification-${type}`,
				message: title,
				description: msg,
				duration: API_MSG_TIME,
				icon: type === API_SUCCESS ? <Icon component={CheckGreen} /> : <Icon component={CloseRed} />
			});
			dispatch(clearApiMsg());
		}
	}, []);

	useEffect(() => {
		messageTrigger(successMessage, API_SUCCESS, API_SUCCESS_INFO);
	}, [successMessage]);

	useEffect(() => {
		messageTrigger(errorMessage, API_ERROR);
	}, [errorMessage]);

	return null;
};

export default React.memo(ApiMessage);